import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureSet } from '../../models/feature.model';
import { AuthService } from '../../services/auth/auth.service';
import { UserPermissionsService } from '../../services/user-permissions/user-permissions.service';

export const authGuard: CanActivateFn = async (route) => {
  const auth = inject(AuthService);
  const permissions = inject(UserPermissionsService);
  const router = inject(Router);
  const featureSet = route.data['featureSet'] as FeatureSet | undefined;
  const requiredPermission = route.data['requiredPermission'] as
    | string
    | undefined;

  // Wait for tokens and policies to be loaded.
  await auth.initialized();

  const canAccess =
    permissions.canView(featureSet) &&
    (!requiredPermission || permissions.permissionTo(requiredPermission)());
  return featureSet === 'rma' && !canAccess
    ? router.createUrlTree(['/unauthorized'])
    : canAccess;
};
